import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { useCitadel } from "./use-citadel";

/**
 * The organisation's roles with their member counts — the read behind the roles table and
 * behind the per-user roles view.
 *
 * The query waits for the rule that opens it. `GET /roles` carries
 * `citadelGate("manage", "Permission")`, and the rules arrive one request after the page does,
 * so firing before they are known would toast a 403 at every caller who does not hold it — and
 * at every caller who does, once, on the first render.
 */
export function useRoles() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	const query = useQuery({
		queryFn: async () => {
			const response = await client.roles.index.$get();
			const data = await responseHandler(response);
			return data.roles;
		},
		queryKey: ["roles"],
		enabled: citadel?.can("manage", "Permission") === true,
	});

	/** Return */
	return { ...query, roles: guardArray(query.data) };
}
